<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex><h1 class="display-2">Asignación permisos de Roles</h1></v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex>
                <v-autocomplete label="Seleccione rol"
                                item-value="id"
                                item-text="display_name"
                                :items="roles"
                                :loading="loadingRole"
                                v-model="rol"
                                @input="roleSelected"></v-autocomplete>
            </v-flex>
            <v-flex>
                <v-btn :loading="actualizando" @click.native="actualizarPermisos">Actualizar permisos</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex>
                <v-autocomplete
                        prepend-icon="vpn_key"
                        color="green"
                        hide-selected
                        clearable
                        label="Permisos asignados"
                        item-value="id"
                        item-text="display_name"
                        v-model="permissions_id"
                        :items="permissions"
                        :loading="asignando"
                        @input="permissionSync"
                        multiple
                        chips
                >
                    <template slot="item" slot-scope="data">
                        <v-list-tile v-on="data.tile.on" v-bind="data.tile.props">
                            <v-list-tile-content>
                                <v-list-tile-title v-html="data.item.display_name"></v-list-tile-title>
                                <v-list-tile-sub-title v-html="data.item.description"></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </v-autocomplete>
            </v-flex>
            <v-flex>
                <v-autocomplete
                        prepend-icon="person"
                        clearable
                        label="Usuarios asignados"
                        item-value="id"
                        item-text="name"
                        v-model="user_id"
                        :items="users"
                        @input="asignaUsu"
                        :loading="asignando"
                        multiple
                        chips
                >
                    <template slot="selection" slot-scope="data">
                        <v-chip
                                :selected="data.selected"
                                :key="JSON.stringify(data.item)"
                                close
                                class="chip--select-multi"
                                @input="data.parent.selectItem(data.item)"
                        >
                            <v-avatar>
                                <img :src="(data.item.avatar)? data.item.avatar : 'img/user-image.png'">
                            </v-avatar>
                            {{ data.item.name }}
                        </v-chip>
                    </template>
                </v-autocomplete>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-text-field
                        label="Descuento comercial hasta %"
                        v-model="desc_com"
                        @change="descuentoSet('com',desc_com)"
                        clearable
                        hint="Determina hasta que porcentaje tiene permitido el rol aplicar de descuento COMERCIAL al precio de items del presupuesto"
                ></v-text-field>
            </v-flex>
            <v-flex>
                <v-text-field
                        label="Descuento estratégico hasta %"
                        v-model="desc_est"
                        @change="descuentoSet('est',desc_est)"
                        clearable
                        hint="Determina hasta que porcentaje tiene permitido el rol aplicar de descuento ESTRATÉGICO al precio de items del presupuesto"
                ></v-text-field>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import usersMixin from '../../mixins/auth/users'
    import rolesMixin from '../../mixins/auth/roles'
    import permissionsMixin from '../../mixins/auth/permissions'
    import {mapActions} from 'vuex'

    export default {
        name: 'permisos',
        mixins: [usersMixin, rolesMixin, permissionsMixin],
        data() {
            return {
                asignando: false,
                loading: -1,
                loadingAsig: -1,
                actualizando: false,
                rol: '',
                roles: [],
                users: [],
                grupo: '',
                permissions: [],
                permissions_id: [],
                user_id: [],
                loadingRole: false,
                tipo: 'perm',
                rutas: [],
                filtro: '',
                desc_com: '',
                desc_est: ''
            }
        },
        mounted() {
            this.datos();
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            datos() {
                this.rolesList(r => {
                    this.roles = r;
                }, err => {
                    console.log(err)
                });
                this.permissionsList(r => {
                    this.permissions = r;
                    this.rolePermissionsGet();
                }, err => {
                    console.log(err);
                });
                this.usersList(r => {
                    this.users = r;
                }, err => {
                    console.log(err);
                })

            },
            asignaUsu() {
                this.asignando = true;
                this.roleUsersSync({
                    user_id: this.user_id,
                    role_id: this.rol
                }, r => {
                    this.msj = r;
                    this.asignando = false;
                }, err => {
                    this.asignando = false;
                })
            },
            descuentoSet(tipo, desc) {
                if(!this.rol){
                    return false;
                }
                this.rolesDescuentoSet({
                    role_id: this.rol,
                    desc: desc,
                    tipo: tipo
                }, r => {
                    this.msjShow(r)
                }, err => {
                    this.msjShow({tipo: err, txt: 'Error al asignar descuento'})
                })
            },
            descuentoGet() {
                this.rolesDescuentoGet({
                    role_id: this.rol
                }, r => {
                    this.desc_com = r.desc_com;
                    this.desc_est = r.desc_est;
                }, err => {
                    this.msjShow({tipo: err, txt: 'Error al obtener descuento'})
                })
            },
            permissionSync() {
                this.asignando = true;
                this.rolesPermissionsSync({
                    role_id: this.rol,
                    permissions_id: this.permissions_id
                }, r => {
                    this.msj = r;
                    this.asignando = false;
                }, err => {
                    this.asignando = false;
                })
            },
            roleSelected() {
                this.rolePermissionsGet();
                this.roleUsersGet();
                this.descuentoGet();
            },
            rolePermissionsGet() {
                if (!this.rol) {
                    return false;
                }
                this.loadingRole = true;
                let self = this;
                this.permissions_id = [];
                this.rolesPermissions({role_id: this.rol}, r => {
                    r.forEach((e) => {
                        self.permissions_id.push(e.id)
                    })
                    this.loadingRole = false
                }, err => {
                    alert(err)
                    this.loadingRole = false
                })

            },
            roleUsersGet() {
                if (!this.rol) {
                    return false;
                }
                this.loadingRole = true;
                this.user_id = [];
                this.roleUsers({
                    role_id: this.rol
                }, r => {
                    r.forEach((e) => {
                        this.user_id.push(e.id)
                    });
                    this.loadingRole = false
                }, err => {
                    console.log(err)
                    this.loadingRole = false
                })

            },
            roleAdd() {
                this.adding = true
                this.$http.post('roles-add', this.a)
                    .then(r => {
                        this.rolesList()
                        this.adding = false
                        this.addDiag = false
                    }, err => {
                        alert(err)
                        this.adding = false
                    });
            },
            actualizarPermisos() {
                this.actualizando = true;
                let rec = (arr) => {
                    arr.forEach(r => {
                        if (r.children) {
                            rec(r.children);
                        } else {
                            let name = (r.name) ? r.name : r.path;
                            let nombre = (r.nombre) ? r.nombre : name;
                            this.rutas.push({name: name, nombre: nombre})
                        }
                    })
                };
                rec(this.$router.options.routes);
                this.$http.post('permissions/actualiza-rutas', {rutas: this.rutas})
                    .then(r => {
                        this.datos();
                        this.actualizando = false;
                    })
                    .catch(err => {
                        console.log('Error al actualizar permisos', err)
                        this.actualizando = false;
                    })
            }
        }
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/auth/roles_asignacion.vue